import React, { useState } from 'react';
import {
  setBygpctFilterToggled,
  setBygOmfangFilter,
} from '../../../store/actions';
import { connect } from 'react-redux';
// import QuestionSquare from '../../Icons/Light/QuestionSquare';
import FilterSlider from './FilterSlider';
import SwatchBookIcon from '../../common/Icons/Light/SwatchBook';
import {
  IAppState,
  activeStyle as activeStyleEnum,
  BygOmfangFilter,
  IBygOmfangFilter,
} from '../../../store/interfaces/state';
import { setActiveStyle as setActiveStyleAction } from '../../../store/actions';
import { neutral } from '../../../style/colors';
import RadioButtonsHorizontal from '../../common/RadioButtonsHorizontal';

const BebyggelsesOmfang = (props: IBebyggelsesOmfangPropTypes) => {
  const {
    toggled,
    setToggled,
    filter,
    setFilter,
    isActiveStyle,
    setActiveStyle,
    activeStyle,
  } = props;
  const className = isActiveStyle ? 'active-style' : '';
  const swatchBookIcon = (
    <SwatchBookIcon
      width={20}
      color={isActiveStyle ? neutral[600] : neutral[300]}
    />
  );
  const radioButtons = [
    {
      name: 'Max bebyggelsesprocent',
      title: 'Max bebyggelsespct.',
      value: BygOmfangFilter.bebyggelsesProcent,
    },
    {
      name: 'Max etagemeter',
      title: 'Max etagemeter',
      value: BygOmfangFilter.etageMeter,
    },
    {
      name: 'Max rumfang',
      title: 'Max rumfang',
      value: BygOmfangFilter.rumfang,
    },
  ];
  const [checkedRadioButtonValue, setCheckedRadioButtonValue] = useState(
    filter.selectedFilter
  );
  return (
    <FilterSlider
      className={className}
      title={'Bebyggelsesomfang'}
      icon={swatchBookIcon}
      iconToggled={activeStyle === activeStyleEnum.bygOmfang}
      onValueChange={vals =>
        setFilter({ filter: vals, selectedFilter: filter.selectedFilter })
      }
      valueDenomination={
        filter.selectedFilter === BygOmfangFilter.bebyggelsesProcent ? (
          '%'
        ) : filter.selectedFilter === BygOmfangFilter.etageMeter ? (
          'm'
        ) : (
              <span>
                m<sup style={{ fontSize: 10 }}>3</sup>
              </span>
            )
      }
      values={filter.filter}
      minValue={0}
      maxValue={
        filter.selectedFilter === BygOmfangFilter.bebyggelsesProcent
          ? 100
          : filter.selectedFilter === BygOmfangFilter.etageMeter
            ? 10
            : 30
      }
      toggled={toggled}
      setToggled={setToggled}
      onIconClick={() => setActiveStyle(activeStyleEnum.bygOmfang)}
      height={160}
    >
      <RadioButtonsHorizontal
        choices={radioButtons}
        // onChange={setCheckedRadioButtonValue}
        onChange={val => {
          setCheckedRadioButtonValue(val);
          setFilter({
            filter:
              val === BygOmfangFilter.bebyggelsesProcent
                ? [0, 100]
                : val === BygOmfangFilter.etageMeter
                  ? [0, 10]
                  : [0, 30],
            selectedFilter: val,
          });
        }}
        selectedRadioButton={checkedRadioButtonValue}
      />
    </FilterSlider>
  );
};
const mapStateToProps = (state: IAppState) => {
  return {
    toggled: state.filterToggled.maxBygpct,
    filter: state.filters.bygOmfang,
    isActiveStyle: state.style.activeStyle === activeStyleEnum.bygOmfang,
    activeStyle: state.style.activeStyle,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setToggled: toggled => {
      dispatch(setBygpctFilterToggled(toggled));
    },
    setFilter: bygOmfangFilter => {
      dispatch(setBygOmfangFilter(bygOmfangFilter));
    },
    setActiveStyle: style => {
      dispatch(setActiveStyleAction(style));
    },
  };
};
interface IBebyggelsesOmfangPropTypes {
  setToggled: Function;
  toggled: boolean;
  filter: IBygOmfangFilter;
  setFilter: Function;
  isActiveStyle: boolean;
  setActiveStyle: Function;
  activeStyle: string;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BebyggelsesOmfang);
